import { useGetRoutingInfo } from "../shared/useQueryRoutingInfo"
import { Workflows } from "../steps/medical-questions/workflows"

export const useMedicalInfoWorkflow = () => {
  const workflow = useGetWorkflow()
  const IsAMAB = workflow === Workflows.AMAB_MEDICAL_QUESTIONS
  const IsAFAB = workflow === Workflows.AFAB_MEDICAL_QUESTIONS
  const decline = workflow === Workflows.DECLINE_MEDICAL_QUESTIONS
  return { workflow, IsAMAB, IsAFAB, decline }
}

function useGetWorkflow(): Workflows {
  const { data: routingData } = useGetRoutingInfo()
  const journey = routingData?.journey
  const preservation = routingData?.preservationInterest
  const medicalPreference = routingData?.amabAfabMedicalPreference
  const afabJourneys = ["TRY_PREGNANT", "PREGNANT", "MENOPAUSE"]
  const amabJourneys = ["LOW_TESTOSTERONE"]

  if (journey === "PRESERVATION") {
    if (preservation === "PRESERVE_EGGS") {
      return Workflows.AFAB_MEDICAL_QUESTIONS
    } else if (preservation === "PRESERVE_SPERM") {
      return Workflows.AMAB_MEDICAL_QUESTIONS
    }
  } else if (journey === "ASSISTED_REPRODUCTION") {
    if (medicalPreference === "AFAB_PREF") {
      return Workflows.AFAB_MEDICAL_QUESTIONS
    } else if (medicalPreference === "AMAB_PREF") {
      return Workflows.AMAB_MEDICAL_QUESTIONS
    } else if (medicalPreference === "DECLINED_HEALTH_QS") {
      return Workflows.DECLINE_MEDICAL_QUESTIONS
    }
  } else if (afabJourneys.includes(journey)) {
    return Workflows.AFAB_MEDICAL_QUESTIONS
  } else if (amabJourneys.includes(journey)) {
    return Workflows.AMAB_MEDICAL_QUESTIONS
  }
}
